<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-12-31_uusivuosi";
    let title = "Uuden vuoden info!";
    let titlePic = "/svelte-site/img/ajankohtaista/uusivuosi_pieni.jpg";
    let firstPara = "Alvimuutos vuodelle 2025 | Uusi ryhmätunti viikkoon | Kehonhuollot ja pilatekset alkavat 5.1.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <h1>{title}</h1>
                    <b>Hyvä tietää vuoden vaihtuessa</b>
                    <p>Vuosi vaihtuu, ja niin vaihtuvat myös jotkin asiat Dynamosalilla. Valitettavasti alv-muutoksen
                        myötä (10% alvikanta nousee 14%:iin) joudumme nostamaan hieman hintoja. Uudet
                        hinnat tulevat voimaan vuoden alusta. Tarkista päivitetty hinnasto <a
                                href="/hinnasto">tästä.</a></p>
                    <b>SykeKaski myös tiistaisin 7.1. lähtien</b>
                    <p>Olemme lisänneet kalenteriin yhden uuden ryhmätunnin viikkoon. SykeKaski-tunti pidetään
                        tiistaisin klo 19. Tunti kestää 45 minuuttia. Ensimmäinen uuden viikko-ohjelman mukainen
                        treeni starttaa
                        tiistaina 7.1. ja jatkuu ainakin kevään 2025 ajan.</p>
                    <b>Nivelet notkeiksi 5.1. lähtien</b>
                    <p>Kehonhuoltoa ja pilatesta on jälleen tarjolla 5.1. alkaen sunnuntaisin! Kehonhuolto auttaa ihan oikeasti palautumaan
                        paremmin ja
                        pitämään paikat notkeina. Teepä sen verran uuden vuoden lupauksia, että huollat kroppaa tänä vuonna hieman
                        useammin.
                    </p>
                    <p>
                        Kiitos vuodesta 2024 ja onnea uuteen vuoteen! Pidetään yhdessä huolta siitä, että treeni
                        maistuu ja keho voi hyvin.
                    </p>

                    <br>
                    Uuden vuoden toivotuksin
                    <br>
                    Dynamon koutsit
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src="/svelte-site/img/ajankohtaista/uusivuosi_pieni.jpg"/>
                </div>
            </div>


        </article>
    </div>
{/if}
